export function formatFCFA(amount: number | null | undefined): string {
  if (amount == null || Number.isNaN(amount)) return "0 FCFA";
  const formatted = amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  return `${formatted} FCFA`;
}

export function parseFCFA(str: string): number {
  return parseInt(str.replace(/[^0-9]/g, ""), 10);
}

export function calculateTVA(amountHT: number, rate: number): number {
  // Integer-safe TVA: convert rate to basis points (e.g. 0.18 → 1800/10000)
  // to avoid floating-point artifacts. Must match backend calculation exactly.
  const rateBps = Math.round(rate * 10000);
  return Math.round((amountHT * rateBps) / 10000);
}

export function calculateLineTotals(params: {
  unit_price_ht_fcfa: number;
  quantity: number;
  tva_rate: number;
}): {
  line_ht_fcfa: number;
  line_tva_fcfa: number;
  line_ttc_fcfa: number;
} {
  const line_ht_fcfa = params.unit_price_ht_fcfa * params.quantity;
  const line_tva_fcfa = calculateTVA(line_ht_fcfa, params.tva_rate);
  return {
    line_ht_fcfa,
    line_tva_fcfa,
    line_ttc_fcfa: line_ht_fcfa + line_tva_fcfa,
  };
}
